import React, { useState, memo, useCallback } from "react";
import QalqiLogo from "./QalqiLogo";
import MenuIcon from "./MenuIcon";
import { slides, SlideKey } from "../config/slides";
import { useNavigation } from "../context/NavigationContext";
import "./NavigationMobile.css";

export interface NavigationMobileProps {
    activeSlide?: SlideKey;
}

const NavigationLinks = ({ activeSlide, closeMenu }: { activeSlide?: SlideKey, closeMenu: () => void }) => {
    const { scrollToIndex } = useNavigation();

    const handleNavigation = useCallback((hash: string, index: number) => {
        closeMenu();
        scrollToIndex(index);
        window.history.replaceState(null, "", hash);
    }, [closeMenu, scrollToIndex]);

    const linkStyle: React.CSSProperties = {
        display: "flex",
        alignItems: "center",
        gap: 10,
        cursor: "pointer",
        textDecoration: "none",
        fontSize: "16px",
        padding: "5px 0"
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "15px", alignItems: "flex-end", width: "100%" }}>
            {slides.map((slide) => {
                const isActive = activeSlide === slide.key;
                const Icon = slide.icon;
                const slideIndex = slides.findIndex(s => s.key === slide.key);

                if (slide.type === "link") {
                    return (
                        <a
                            key={slide.key}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                ...linkStyle,
                                color: isActive ? (slide.iconColor || "#C82128") : "#2E2E2E",
                                fontWeight: isActive ? "bold" : "normal",
                            }}
                            href={slide.url}
                            onClick={closeMenu}
                        >
                            <Icon width={18} height={18} /> {slide.label}
                        </a>
                    )
                }

                return (
                    <a
                        key={slide.key}
                        href={slide.hash}
                        onClick={(e) => {
                            e.preventDefault();
                            handleNavigation(slide.hash || "", slideIndex);
                        }}
                        style={{
                            ...linkStyle,
                            color: isActive ? (slide.iconColor || "#C82128") : "#2E2E2E",
                            fontWeight: isActive ? "bold" : "normal",
                        }}
                    >
                        <Icon
                            fill={isActive ? (slide.iconColor || "currentColor") : "#414141ff"}
                            width={18} height={18} /> {slide.label}
                    </a>
                )
            })}
        </div>
    )
}


const NavigationMobile: React.FC<NavigationMobileProps> = ({ activeSlide }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="nav-mobile-wrapper">
            <div className="nav-mobile-header">
                <a href="/" style={{ pointerEvents: "all", display: "flex", alignItems: "center" }}>
                    <QalqiLogo width={83} height={18} />
                </a>
                <div
                    className="nav-mobile-toggle"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <MenuIcon width={24} height={24} />
                </div>
            </div>

            {isOpen && (
                <div className="nav-mobile-menu">
                    <NavigationLinks activeSlide={activeSlide} closeMenu={() => setIsOpen(false)} />
                </div>
            )}
        </div>
    );
};

export default memo(NavigationMobile);
